import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import {
  TuiDataListModule,
  TuiDropdownModule,
  TuiHostedDropdownModule,
  TuiSvgModule,
} from '@taiga-ui/core';
import { Store } from '@ngxs/store';
import { TuiAvatarModule } from '@taiga-ui/kit';
import { take } from 'rxjs';
import { Router, RouterLink } from '@angular/router';
import { Logout } from '@store/auth/auth.actions';
import { UpperCasePipe } from '@angular/common';
import { TuiActiveZoneModule } from '@taiga-ui/cdk';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthState } from '@store/auth/auth.state';
import { RouteNames } from '../../../../route-names';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [
    TuiDropdownModule,
    TuiAvatarModule,
    TuiDataListModule,
    TuiHostedDropdownModule,
    RouterLink,
    UpperCasePipe,
    TuiActiveZoneModule,
    TranslocoPipe,
    TuiSvgModule,
  ],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  userPersonalData = this.store.selectSignal(AuthState.getUserPersonalData);

  userFullName = computed(() => {
    const data = this.userPersonalData();
    const parts = [data?.firstName, data?.lastName].filter(Boolean);
    return parts.length ? parts.join(' ') : data?.email ?? '';
  });

  constructor(
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  protected logout() {
    this.store
      .dispatch(new Logout())
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.router.navigate([RouteNames.MAIN_PAGE]);
        },
      });
  }
}
